var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse, _ellipse2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel7Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint0_linear_7088_3748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint1_linear_7088_3748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.87 267.009L389.87 251.99L685.002 241.477Z",
    fill: "url(#paint2_linear_7088_3748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint3_linear_7088_3748)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint4_linear_7088_3748)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.079 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint5_linear_7088_3748)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.09 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint6_linear_7088_3748)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint7_linear_7088_3748)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint8_linear_7088_3748)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.998 0.989276L402.262 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint9_linear_7088_3748)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint10_linear_7088_3748)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint11_linear_7088_3748)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint12_radial_7088_3748)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint13_radial_7088_3748)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.796 156.564L363.743 175.767H395.37V153C391.957 152.989 388.54 154.177 385.796 156.564Z",
    fill: "#FDF0BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.823 156.542C402.108 154.192 398.743 153.011 395.374 153V175.767H427.001L404.823 156.542Z",
    fill: "url(#paint14_linear_7088_3748)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M318.436 188.048L313.887 216.935L338.114 196.607L323.479 179.166C320.857 181.351 319.003 184.459 318.436 188.048Z",
    fill: "#FDF0BC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.998 175.805C329.408 175.746 326.069 177.007 323.483 179.166L338.118 196.607L362.345 176.279L332.998 175.805Z",
    fill: "url(#paint15_linear_7088_3748)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M287.078 255.464L302.158 280.519L307.649 249.374L285.231 245.416C284.624 248.778 285.202 252.349 287.078 255.464Z",
    fill: "#FDF0BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M290.358 236.727C287.574 238.992 285.827 242.104 285.231 245.418L307.652 249.372L313.143 218.227L290.358 236.727Z",
    fill: "url(#paint16_linear_7088_3748)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M306.387 327.266L334.046 336.763L318.234 309.373L298.516 320.756C300.212 323.721 302.948 326.086 306.387 327.266Z",
    fill: "url(#paint17_linear_7088_3748)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M296.857 310.803C296.176 314.327 296.838 317.836 298.512 320.76L318.23 309.376L302.418 281.986L296.857 310.803Z",
    fill: "url(#paint18_linear_7088_3748)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M367.333 369.859L394.624 359.358L364.906 348.541L357.119 369.936C360.323 371.113 363.942 371.164 367.333 369.859Z",
    fill: "url(#paint19_linear_7088_3748)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M349.449 363.371C351.192 366.508 353.955 368.77 357.118 369.932L364.904 348.538L335.186 337.721L349.449 363.371Z",
    fill: "url(#paint20_linear_7088_3748)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M441.401 363.308L455.557 337.721L425.839 348.538L433.625 369.933C436.832 368.774 439.639 366.49 441.401 363.308Z",
    fill: "url(#paint21_linear_7088_3748)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M423.529 369.834C426.883 371.118 430.451 371.074 433.622 369.93L425.835 348.535L396.117 359.352L423.529 369.834Z",
    fill: "url(#paint22_linear_7088_3748)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M493.926 310.686L488.325 281.986L472.513 309.376L492.231 320.76C493.945 317.806 494.625 314.253 493.926 310.686Z",
    fill: "url(#paint23_linear_7088_3748)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M484.433 327.171C487.824 325.998 490.531 323.669 492.226 320.756L472.509 309.373L456.697 336.763L484.433 327.171Z",
    fill: "url(#paint24_linear_7088_3748)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M500.337 236.609L477.596 218.227L483.087 249.372L505.508 245.418C504.931 242.056 503.165 238.897 500.337 236.609Z",
    fill: "url(#paint25_linear_7088_3748)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M503.661 255.339C505.508 252.261 506.085 248.737 505.508 245.416L483.086 249.37L488.578 280.515L503.661 255.339Z",
    fill: "url(#paint26_linear_7088_3748)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M457.635 175.741L428.398 176.274L452.625 196.602L467.26 179.161C464.652 176.962 461.272 175.675 457.635 175.741Z",
    fill: "url(#paint27_linear_7088_3748)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M472.222 187.955C471.656 184.409 469.835 181.342 467.261 179.168L452.626 196.609L476.853 216.937L472.222 187.955Z",
    fill: "url(#paint28_linear_7088_3748)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M395.369 342.081C438.027 342.081 472.608 307.5 472.608 264.843C472.608 222.186 438.027 187.605 395.369 187.605C352.712 187.605 318.131 222.186 318.131 264.843C318.131 307.5 352.712 342.081 395.369 342.081Z",
    fill: "url(#paint29_radial_7088_3748)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M395.369 180.705C348.901 180.705 311.23 218.371 311.23 264.839C311.23 311.307 348.901 348.977 395.369 348.977C441.837 348.977 479.507 311.307 479.507 264.839C479.507 218.371 441.837 180.705 395.369 180.705ZM395.369 342.069C352.715 342.069 318.138 307.493 318.138 264.839C318.138 222.185 352.715 187.609 395.369 187.609C438.023 187.609 472.6 222.185 472.6 264.839C472.6 307.493 438.023 342.069 395.369 342.069Z",
    fill: "url(#paint30_linear_7088_3748)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M395.369 169.969C342.972 169.969 300.498 212.442 300.498 264.839C300.498 317.235 342.972 359.709 395.369 359.709C447.766 359.709 490.24 317.235 490.24 264.839C490.24 212.442 447.766 169.969 395.369 169.969ZM395.369 348.936C348.923 348.936 311.271 311.284 311.271 264.839C311.271 218.393 348.923 180.745 395.369 180.745C441.815 180.745 479.467 218.397 479.467 264.842C479.467 311.288 441.815 348.936 395.369 348.936Z",
    fill: "url(#paint31_linear_7088_3748)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M374.075 303.545C372.788 303.545 371.592 303.133 370.537 302.398C370.401 302.306 370.309 302.214 370.217 302.122C370.125 302.078 370.077 301.986 370.033 301.938C369.849 301.798 369.757 301.662 369.621 301.526C369.529 301.434 369.481 301.342 369.393 301.25L369.349 301.206C369.257 301.114 369.209 301.022 369.165 300.93L369.073 300.791C368.889 300.515 368.753 300.239 368.613 299.963C368.569 299.827 368.521 299.687 368.473 299.551C368.429 299.411 368.381 299.231 368.337 299.091C368.289 298.907 368.245 298.679 368.197 298.448C368.197 298.356 368.153 298.22 368.153 298.128C368.153 297.944 368.109 297.76 368.109 297.576C368.109 297.256 368.153 296.932 368.201 296.565L371.739 275.983L356.807 261.418C356.531 261.142 356.255 260.822 356.027 260.498C355.751 260.086 355.567 259.763 355.431 259.395C355.387 259.259 355.295 259.075 355.247 258.843C355.107 258.291 355.019 257.74 355.019 257.144C355.019 256.96 355.019 256.824 355.019 256.64C355.019 256.364 355.063 256.088 355.155 255.812C355.155 255.768 355.199 255.676 355.199 255.629C355.247 255.489 355.247 255.353 355.291 255.217C355.291 255.172 355.335 255.077 355.383 254.941C355.427 254.801 355.475 254.665 355.567 254.529C355.703 254.253 355.843 253.977 356.071 253.657C356.163 253.473 356.299 253.337 356.439 253.197C356.439 253.197 356.439 253.153 356.483 253.153L357.219 251.958H357.862C357.954 251.91 357.998 251.866 358.09 251.818C358.182 251.774 358.366 251.682 358.502 251.59C358.686 251.498 358.914 251.406 359.19 251.314C359.282 251.27 359.418 251.222 359.558 251.222C359.742 251.178 359.926 251.13 360.154 251.083L380.828 248.096L389.924 229.489C390.935 227.422 393.002 226.135 395.297 226.135C396.952 226.135 398.56 226.823 399.707 228.018C399.891 228.246 400.075 228.43 400.211 228.662C400.395 228.937 400.579 229.213 400.715 229.489L409.95 248.14L430.577 251.127C432.875 251.447 434.759 253.058 435.446 255.261C435.494 255.401 435.538 255.489 435.538 255.629C435.538 255.673 435.538 255.673 435.583 255.72C435.627 255.86 435.674 255.996 435.674 256.18C435.674 256.224 435.674 256.224 435.674 256.272C435.719 256.456 435.719 256.592 435.719 256.776C435.766 257.648 435.627 258.567 435.259 259.395C435.119 259.763 434.939 260.083 434.707 260.406L434.659 260.45C434.431 260.77 434.155 261.094 433.88 261.37L418.947 275.935L422.485 296.469C422.853 298.72 421.981 300.971 420.094 302.35C419.635 302.67 419.083 302.994 418.531 303.178C418.483 303.178 418.439 303.225 418.347 303.225C417.751 303.409 417.152 303.501 416.556 303.501C415.592 303.501 414.625 303.273 413.753 302.813L395.286 293.118L376.819 302.813C376.002 303.317 375.039 303.545 374.075 303.545Z",
    fill: "#DF771E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 229.074V267.068L382.615 250.852L392.539 230.777C393.138 229.674 394.241 229.074 395.297 229.074Z",
    fill: "#FFFAF6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M432.648 256.229L395.342 267.072L408.02 250.855L430.165 254.07C431.409 254.298 432.28 255.17 432.648 256.229Z",
    fill: "#FEE0AC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M418.362 300.006L395.3 267.066L415.791 274.923L419.557 296.976C419.829 298.263 419.277 299.363 418.362 300.006Z",
    fill: "#ECB76B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 267.066V289.807L375.494 300.234C374.347 300.83 373.151 300.646 372.232 300.006L395.297 267.066Z",
    fill: "#F1A341"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M407.98 250.852L395.298 267.068V229.074C396.125 229.074 396.953 229.394 397.549 230.038C397.641 230.13 397.733 230.266 397.825 230.406C397.917 230.545 398.009 230.682 398.053 230.818L407.98 250.852Z",
    fill: "#FFE9BA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M432.555 258.294C432.463 258.478 432.371 258.662 432.279 258.846C432.14 259.03 432.004 259.166 431.868 259.35L415.835 274.97L395.345 267.114L432.651 256.271C432.651 256.316 432.695 256.363 432.695 256.411C432.695 256.459 432.743 256.503 432.743 256.595C432.743 256.643 432.743 256.643 432.743 256.643C432.743 256.687 432.743 256.735 432.743 256.779C432.743 256.871 432.743 256.919 432.743 257.007C432.787 257.419 432.739 257.879 432.555 258.294Z",
    fill: "#E49632"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M418.363 300.006C418.135 300.19 417.859 300.326 417.535 300.418C417.491 300.418 417.491 300.418 417.443 300.463C416.708 300.691 415.88 300.646 415.1 300.234L395.298 289.807V267.066L418.363 300.006Z",
    fill: "#E29136"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 267.066L372.236 300.006C372.192 299.959 372.144 299.914 372.1 299.867C372.056 299.823 372.008 299.775 371.96 299.727C371.916 299.683 371.868 299.635 371.776 299.543C371.729 299.499 371.684 299.451 371.637 299.403C371.589 299.355 371.592 299.359 371.592 299.311C371.548 299.267 371.501 299.219 371.501 299.172C371.409 299.035 371.317 298.896 371.272 298.76C371.228 298.715 371.228 298.62 371.181 298.532C371.136 298.44 371.136 298.392 371.089 298.304C371.044 298.212 371.044 298.076 371.044 297.984C371.044 297.939 371.044 297.844 371.044 297.8C371.044 297.708 371.044 297.616 371.044 297.524C371.044 297.34 371.044 297.156 371.089 296.972L374.855 274.919L395.297 267.066Z",
    fill: "#FED891"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M395.298 267.067L357.992 256.224C357.992 256.18 358.036 256.132 358.036 256.084C358.08 255.992 358.08 255.9 358.128 255.856C358.22 255.672 358.312 255.536 358.404 255.396C358.448 255.304 358.496 255.257 358.588 255.168C358.635 255.124 358.679 255.029 358.771 254.984C358.816 254.94 358.911 254.848 358.955 254.801C358.999 254.753 359.091 254.709 359.139 254.661C359.231 254.617 359.323 254.521 359.415 254.477C359.459 254.433 359.551 254.385 359.643 254.385C359.783 254.341 359.871 254.293 360.011 254.245C360.055 254.245 360.103 254.201 360.195 254.201C360.287 254.157 360.423 254.157 360.563 254.109L382.708 250.895L395.298 267.067Z",
    fill: "#FFF3D9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M395.297 267.068L374.854 274.969L358.822 259.348C358.638 259.209 358.546 259.028 358.41 258.844C358.318 258.661 358.182 258.477 358.134 258.293C358.09 258.201 358.042 258.109 358.042 258.017C357.95 257.741 357.902 257.421 357.902 257.145C357.902 257.053 357.902 256.961 357.902 256.869C357.902 256.733 357.902 256.641 357.95 256.502C357.95 256.457 357.994 256.41 357.994 256.318C357.994 256.274 358.038 256.226 358.038 256.182L395.297 267.068Z",
    fill: "#ECB76B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7088_3748",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7088_3748",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7088_3748",
    x1: 657.591,
    y1: 261.94,
    x2: 389.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7088_3748",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7088_3748",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7088_3748",
    x1: 236.466,
    y1: 14.8011,
    x2: 383.467,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7088_3748",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7088_3748",
    x1: 132.013,
    y1: 119.262,
    x2: 386.629,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7088_3748",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7088_3748",
    x1: 553.655,
    y1: 14.7982,
    x2: 406.654,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7088_3748",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7088_3748",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_7088_3748",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_7088_3748",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE08A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7088_3748",
    x1: 396.92,
    y1: 164.383,
    x2: 425.963,
    y2: 164.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7088_3748",
    x1: 332.326,
    y1: 186.599,
    x2: 361.311,
    y2: 162.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCC15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7088_3748",
    x1: 313.662,
    y1: 218.161,
    x2: 297.306,
    y2: 245.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7088_3748",
    x1: 305.973,
    y1: 314.427,
    x2: 334.402,
    y2: 333.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC05F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED892B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7088_3748",
    x1: 302.742,
    y1: 282.582,
    x2: 307.805,
    y2: 314.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7088_3748",
    x1: 362.436,
    y1: 359.62,
    x2: 390.475,
    y2: 365.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F08223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7088_3748",
    x1: 333.783,
    y1: 337.477,
    x2: 359.486,
    y2: 358.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB431"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7088_3748",
    x1: 455.669,
    y1: 337.538,
    x2: 430.031,
    y2: 359.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7088_3748",
    x1: 396.229,
    y1: 361.4,
    x2: 428.942,
    y2: 359.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E56005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7088_3748",
    x1: 489.527,
    y1: 282.101,
    x2: 482.95,
    y2: 314.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7088_3748",
    x1: 498.144,
    y1: 287.739,
    x2: 466.518,
    y2: 342.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6942F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA6F11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7088_3748",
    x1: 476.008,
    y1: 219.148,
    x2: 495.047,
    y2: 247.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7088_3748",
    x1: 487.392,
    y1: 280.435,
    x2: 494.835,
    y2: 247.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7088_3748",
    x1: 459.576,
    y1: 187.453,
    x2: 430.152,
    y2: 173.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7088_3748",
    x1: 459.718,
    y1: 185.65,
    x2: 473.738,
    y2: 216.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBE41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_7088_3748",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395.37 264.842) scale(77.2385 77.2377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8428,
    stopColor: "#FAAA31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7088_3748",
    x1: 395.37,
    y1: 180.704,
    x2: 395.37,
    y2: 348.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0226,
    stopColor: "#FD9A18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3764,
    stopColor: "#FEC752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA422"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7088_3748",
    x1: 395.37,
    y1: 169.691,
    x2: 395.37,
    y2: 359.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1799,
    stopColor: "#FEE7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FEE9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2592,
    stopColor: "#FDECD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2953,
    stopColor: "#FEDA92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#FFCD64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3405,
    stopColor: "#FFC853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7613,
    stopColor: "#FF9114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57E16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel7Badge);
export default __webpack_public_path__ + "static/media/Level7Badge.753f31947938a985754c96ae97a050fa.svg";
export { ForwardRef as ReactComponent };